<template>
  <div>
    <v-btn
      :loading="loading"
      class="mx-2"
      fab
      dark
      small
      color="primary"
      @click="loadGroupes()"
    >
      <v-icon dark>
        mdi-cached
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      groupes: [],
      loading: false,
    };
  },
  props: {
    region: {
      required: true,
    },
  },

  methods: {
    loadGroupes() {
      let self = this;
      self.loading = true;
      self.$firebase
        .firestore()
        .collection("groupes")
        .where("id_region", "in", [
          self.region.id.toString(),
          parseInt(self.region.id),
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var groupe = doc.data();
            groupe.id = doc.id;
            self.groupes.push(groupe);
          });
          self.loading = false;
          self.updateRegion(self.groupes.length);
          self.$emit("updateRegion");
        });
    },

    updateRegion(nombre) {
      let self = this;
      var ref = self.$firebase
        .firestore()
        .collection("regions")
        .doc(self.region.id);

      ref.set(
        {
          nbreGroupe: nombre,
          dateStatGroupe: self.$moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        { merge: true }
      );
    },
  },
};
</script>

<style scoped></style>
